<template>
  <v-container v-if="$auth.check()">
    <v-row>
      <v-col>
        <h1>{{ $t('texts.applications') }}</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-tabs
            v-model="active"
            slider-color="primary"
            color="transparent"
            active-class="text--primary"
          >
            <v-tab
              ripple
              :to="{ path: `/company/${company.id}/applications/ongoing` }"
            >
              {{ $t('texts.open') }}
            </v-tab>
            <v-tab
              ripple
              :to="{ path: `/company/${company.id}/applications/completed` }"
            >
              {{ $t('texts.completed') }}
            </v-tab>
            <v-tabs-items v-model="active">
              <v-card>
                <v-card-text>
                  <router-view/>
                </v-card-text>
              </v-card>
            </v-tabs-items>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapCompanyProfileState } = createNamespacedHelpers('company/profile');

export default {
  name: 'CompanyApplications',
  data() {
    return {
      active: null,
    };
  },
  computed: {
    ...mapCompanyProfileState([
      'company',
    ]),
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep {
    .v-tabs__item--active {
      color: #0d5890;
    }
  }
</style>
